import { Shape } from '@src/validations';
import * as yup from 'yup';
import { PaymentLinkFormI } from '../components/singlePaymentLinkForm';
import { PaymentLinkFormII } from '../components/recurrentPaymentLinkForm';

export const getPaymentLinkValidationSchema = () =>
  yup.object().shape<Shape<PaymentLinkFormI>>({
    amount: yup.string(),
    description: yup.string().required('Please add a description'),
    linkName: yup.string().required('Please add a link name'),
    targetCurrency: yup.string().required('Please select target currency'),
    redirectUrl: yup
      .string()
      .matches(/^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/.*)?$/, 'Enter a valid URL')
  });

export const getRecurrentPaymentLinkValidationSchema = () =>
  yup.object().shape<Shape<PaymentLinkFormII>>({
    amount: yup.string(),
    description: yup.string().required('Please add a description'),
    linkName: yup.string().required('Please add a link name'),
    targetCurrency: yup.string().required('Please select target currency'),
    interval: yup.string(),
    intervalCount: yup.string(),
    customerCanCancelSubscription: yup.boolean(),
    redirectUrl: yup
      .string()
      .matches(/^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/.*)?$/, 'Enter a valid URL')
  });
